<template>
    <div class="text-center mt-12">
        <div v-if="funnel.html_imprint">

        </div>
        <div class="mb-4 flex justify-center text-gray-600 text-xs" v-else-if="funnel.link_imprint || funnel.link_privacy">
            <a :href="funnel.link_imprint" class="ml-2 mr-2" target="_blank" v-if="funnel.link_imprint">Impressum</a>
            <a :href="funnel.link_privacy" class="ml-2 mr-2" target="_blank" v-if="funnel.link_privacy">Datenschutz</a>
        </div>
        <a :href="badgeFootLink" target="_blank" v-if="funnel.settings && funnel.settings.showAffiliate && funnel.settings.showAffiliate != 0" class="mb-6">
            <span class="inline-flex items-center rounded-md bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800">
                <img src="https://www.funnerix.com/img/funnerix-mark.svg" alt="Funnel Builder" class="w-6 h-6 p-1">
                by funnerix
            </span>
        </a>
    </div>
</template>

<script>
import meta_pixel from "./meta_pixel";
export default {
    props: {
        answers: { type: Array },
        debug: { type: Boolean },
        sid: { type: String, required: true },
        meta: { type: Object, required: true },
        funnel: { type: Object, required: true },
        loaded: { type: Boolean, required: true },
    },
    computed: {
        badgeFootLink() {
            let url = "https://www.digistore24.com/redir";
            let digistoreProductIds = "458739,458738,458735";
            let affiliate = this.funnel.ds24_affiliate_id ?? '';
            return url+"/"+digistoreProductIds+"/"+affiliate+"/BADGEFOOT";
        }
    }
}
</script>

<style>

</style>
